module.exports = __webpack_public_path__ + "img/sw06.95a198a8.jpg";